<div id="iframeContainer"></div>

<style type="text/css">
  #gameIFrame {
    width: 100% !important;
    height: 100% !important;
    border: none;
    text-align: center;
    background-color: Black;
  }

  html,
  body {
    width: 100% !important;
    height: 100% !important;
    margin: 0;
    padding: 0;
  }
</style>
